import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Typography } from '@mui/material'
import Truncate from '@src/components/Truncate'
import { decodePageTitle } from '@src/utils/decodeTitle'
import HandleMarkup from '@src/components/HandleMarkup'
import { Link } from '@src/components/Link'
import { TechnicalDocumentSearchFieldsFragment as ContentItemFragment } from '@src/queries/ContentDocumentsSearchQuery.generated'

export const useStyles = makeStyles()((theme) => {
  return {
    root: {
      fontSize: theme.typography.pxToRem(22),
      padding: theme.spacing(8, 4, 8, 4),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6, 0, 6, 0),
      },
    },
    title: {
      display: 'block',
      fontWeight: theme.typography.fontWeightBold,
      '& span': {
        fontSize: theme.typography.pxToRem(22),
      },
      lineHeight: 'normal',
      letterSpacing: theme.typography.pxToRem(-0.22),
    },
    content: {
      fontWeight: theme.typography.fontWeightRegular,
      marginTop: theme.spacing(2),
      lineHeight: theme.typography.pxToRem(24),
      letterSpacing: theme.typography.pxToRem(-0.16),
      fontSize: theme.typography.pxToRem(16),
    },
  }
})

interface ContentItemProps {
  item: ContentItemFragment
  useNextLink?: boolean
}

const ContentItem: React.FC<ContentItemProps> = ({
  item,
  useNextLink = false,
}) => {
  const { classes } = useStyles()
  const id = `content-link-${item.title.replace(/\s/g, '').toLowerCase()}`

  const cleanText = item.text.replace(/(<([^>]+)>)/gi, '').trim()
  const displayText = useNextLink ? decodePageTitle(cleanText) : cleanText

  const titleContent = useNextLink ? (
    <HandleMarkup value={item.title} />
  ) : (
    item.title
  )

  return (
    <div className={classes.root}>
      {useNextLink ? (
        <Link href={item.url} passHref>
          <a className={classes.title} id={id}>
            {titleContent}
          </a>
        </Link>
      ) : (
        <a
          href={item.url}
          className={classes.title}
          id={id}
          target="_blank"
          rel="noreferrer"
        >
          {titleContent}
        </a>
      )}
      <Typography component="div" variant="body2" className={classes.content}>
        <Truncate wordCount={40} commas={false} allowShowMore={false}>
          {displayText}
        </Truncate>
      </Typography>
    </div>
  )
}

export default ContentItem
